<template>
    <div class="seleccion-container">
      <!-- Logo -->
      <div class="logos">
        <img src="@/assets/logo.png" alt="HP y RM" />
      </div>
  
      <!-- Opciones de género -->
      <div class="form-section">
        <h2>Selecciona la opción deseada:</h2>
        <div class="genero-options">
            <button
                v-for="opcion in opciones"
                :key="opcion.valor"
                :class="{ activo: genero === opcion.valor }"
                @click="genero = opcion.valor"
                type="button"
            >
                {{ opcion.texto }}
            </button>
        </div>

  
        <!-- Términos -->
        <label class="terminos">
          <input type="checkbox" v-model="aceptado" />
          Acepto términos y condiciones de la actividad.<br />
          <small>Para mayor información visita: <a href="http://terminosycondiciones.hpinfo.online/" target="_blank">http://terminosycondiciones.hpinfo.online/</a></small>
        </label>
      </div>
  
      <!-- Botón avanzar -->
      <div class="footer">
        <div class="line-button" @click="avanzar">
          <hr />
          <span>Avanzar</span>
          <hr />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
        return {
            aceptado: false,
            opciones: [
            { valor: 'hombre', texto: 'Hombre' },
            { valor: 'mujer', texto: 'Mujer' },
            { valor: 'no_especificar', texto: 'No especificar' },
            ]
        };
    },
    computed: {
    genero: {
        get() {
            return this.$store.state.genero;
        },
        set(value) {
            this.$store.commit('setGenero', value);
        }
        },
    },

    methods: {
      avanzar() {
        if (!this.genero || !this.aceptado) {
          alert('Selecciona una opción y acepta los términos.');
          return;
        }
        this.$router.push({ path: '/tomafoto', query: { genero: this.genero } });
      },
    },
  };
  </script>
  
  <style scoped lang="scss">
  .seleccion-container {
    background-color: #0095d9;
    color: white;
    min-height: 100vh;
    width: 100%;
    padding: 2rem;
    font-family: 'FormaDJRDisplay', sans-serif;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
  }
  
  .logos {
  position: absolute;
  top: 2vh;
  left: 2vw;

  img {
    width: 180px;
    max-width: 45vw;
  }
}

  
  .form-section {
    text-align: left;
    max-width: 600px;
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    align-content: center;
    h2 {
      font-size: 1.5rem;
      margin-bottom: 1rem;
    }
  
    .genero-options {
      display: flex;
      gap: 2rem;
      margin-bottom: 2rem;
  
      label {
        display: flex;
        align-items: center;
        gap: 0.5rem;
      }
    }
  
    .terminos {
      display: block;
      margin-top: 3rem;
      line-height: 1.4;
      letter-spacing: 1px;
      input {
        transform: scale(1.3);
        margin-right: 10px;
      }
      small {
        font-size: 0.9rem;
        display: block;
        margin-top: 0.3rem;
        padding-left: 28px;
      }
  
      a {
        color: white;
        text-decoration: underline;
      }
    }
  }
  
  .footer {
    margin-top: auto;
    width: 100%;
    text-align: center;
    padding-top: 2rem;
    z-index: 3;
    position: relative;
  
    .line-button {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      gap: 1rem;
      flex-direction: column;
 
      span {
        padding: 0.5rem 2rem;
        font-size: 1.1rem;
        border-top: 1px solid #fff;
        border-bottom: 1px solid #fff;
        &:hover {
          background: white;
          color: #0095d9;
          transition: all 0.3s;
        }
      }
  
    }
  }
  .genero-options {
    display: flex;
    gap: 2rem;
    margin-bottom: 2rem;
    justify-content: space-between;
    flex-wrap: wrap;

    button {
        background: transparent;
        border: 2px solid white;
        color: white;
        padding: 0.5rem 1.5rem;
        font-size: 1rem;
        cursor: pointer;
        font-family: inherit;
        transition: all 0.1s ease;
        min-width: 170px;
        // border-radius: 8px;

        &.activo {
        background-color: white;
        color: #0095d9;
        }

        &:hover {
        background-color: rgba(255, 255, 255, 0.2);
        }
    }
}

  </style>
  